// Order Status Constants
// see: app/models/order.rb (AASM column: :status)
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const ORDER_STATUSES = [
  'pending',
  'awaiting_payment',
  'allocated',
  'partial_allocated',
  'out_of_stock',
  'processing',
  'partial_shipped',
  'shipped',
  'canceled',
  'draft',
  'merged',
] as const

export type OrderStatus = typeof ORDER_STATUSES[number]

export function useOrderStatusLabel() {
  const { t } = useTranslation()
  // useCallback：保持回傳函式參照穩定，避免依賴它的 useMemo 每次 render 重算造成無窮 re-render。
  return useCallback((status: string | undefined | null): string => {
    if (!status) return ''
    switch (status as OrderStatus) {
      case 'pending':           return t('enums.order.status.pending')
      case 'awaiting_payment':  return t('enums.order.status.awaiting_payment')
      case 'allocated':         return t('enums.order.status.allocated')
      case 'partial_allocated': return t('enums.order.status.partial_allocated')
      case 'out_of_stock':      return t('enums.order.status.out_of_stock')
      case 'processing':        return t('enums.order.status.processing')
      case 'partial_shipped':   return t('enums.order.status.partial_shipped')
      case 'shipped':           return t('enums.order.status.shipped')
      case 'canceled':          return t('enums.order.status.canceled')
      case 'draft':             return t('enums.order.status.draft')
      case 'merged':            return t('enums.order.status.merged')
      default:                  return status
    }
  }, [t])
}
